const Sizing = {
	sm: "1rem",
	lg: "1.5rem",
	xl: "2rem",
	NAVBAR_HIGHT: "5rem",
};

export default Sizing;
